import { render } from "./ConsultaCausacion.vue?vue&type=template&id=037fd428"
import script from "./ConsultaCausacion.vue?vue&type=script&lang=js"
export * from "./ConsultaCausacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__